import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Can from 'components/Can';
import UnauthorizedAccess from 'components/Error/UnauthorizedAccess';

const PrivateRoute = (props) => {
  const { isLogged, component: Component, permission } = props;

  const user = JSON.parse(localStorage.getItem('user'));

  const getPermission = () => {
    let aux = user.profiles[0].permissions.filter(p => p.name == permission)[0];
    return aux ? true : false;
  }

  return (
    <Route
      {...props}
      component={(moreProps) =>
        isLogged ? (
          permission ? (
            getPermission() ? (
              <Component {...props} {...moreProps} />
            ):(
              <UnauthorizedAccess />
            )
          ) : (
            <Component {...props} {...moreProps} />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default connect((state) => ({
  isLogged: state.user.authenticate,
}))(PrivateRoute);
